require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-will-the-world-bank-provide-remedy-for-those-harme.json") })
        }
      }, "path---en-us-update-will-the-world-bank-provide-remedy-for-those-harme");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-will-the-world-bank-provide-remedy-for-those-harme!./.cache/json/en-us-update-will-the-world-bank-provide-remedy-for-those-harme.json
// module id = 872
// module chunks = 231608221292675